{
  "edit": {
    "title": "School Profile"
  },
  "school_sectors": {
    "government": "Government",
    "catholic": "Catholic",
    "independent": "Independent"
  },
  "school_types": {
    "primary": "Primary",
    "secondary": "Secondary",
    "combined": "Combined",
    "special": "Special"
  },
  "form": {
    "subsections": {
      "school_information": "School Information",
      "school_socio_economic": "School Socio Economic Status"
    },
    "school_information": {
      "subsections": {
        "general_information": "General Information",
        "school_sector": "School Sector",
        "school_status": "School Status",
        "school_teaching_style": "School Teaching Style",
        "school_platforms_used": "School Platform Technology Used"
      },
      "general_information": {
        "school_name": "School Name",
        "school_address": "School Address",
        "contact_email": "Contact Email",
        "contact_number": "Contact Phone Number",
        "school_url": "School URL"
      },
      "school_sector": {
        "school_sector": "School Sector",
        "school_type": "School Type"
      },
      "school_status": {
        "teach_non_year_12_subjects": "Teaches non-year 12 subjects",
        "teach_within_curriculum": "Teaches within curriculum",
        "teach_year_12_subjects_outside_curriculum": "Teaches year 12 subjects outside curriculum"
      },
      "school_teaching_style": {
        "teaching_style_lecture_tutorial": "Lecture/Tutorial style",
        "teaching_style_other": "Other teaching style",
        "teaching_style_other_description": "Other teaching style description",
        "teaching_style_traditional": "Traditional teaching style",
        "teaching_style_world_school": "World school style"
      },
      "school_platforms_used": {
        "platform_technology_google_meet": "Google Meet",
        "platform_technology_microsoft_teams": "Microsoft Teams",
        "platform_technology_other": "Other platform",
        "platform_technology_other_description": "Other platform description",
        "platform_technology_zoom": "Zoom"
      }
    },
    "school_socio_economic": {
      "annual_profile": {
        "title": "Annual Profile",
        "add_label": "Add New Profile",
        "remove_label": "Remove Annual Profile {{index}}",
        "icsea": "ICSEA",
        "icsea_percentile": "ICSEA Percentile",
        "calendar_year": "Calendar Year",
        "calendar_year_unique": "Calendar year must be unique"
      }
    }
  }
}
